import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors, spacing, typography } from '#themes/stena-recycling';

export const ItemRowStyled = styled.div<{ selected?: boolean; actionMenu?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  background: ${({ selected, actionMenu }) =>
    selected && !actionMenu ? colors.background.grey : 'transparent'};
  ${({ actionMenu }) =>
    actionMenu &&
    css`
      height: 48px;
    `}

  &:hover {
    background: ${colors.background.grey};
  }
`;

export const ItemButtonStyled = styled.button<{ selected?: boolean; actionMenu?: boolean }>`
  ${typography.body.large};
  color: ${colors.base.black};
  flex: 1;
  min-width: 0;
  padding: ${spacing.xsmall} ${spacing.xmsmall};
  cursor: pointer;
  background: transparent;
  border: 0;
  text-align: left;
  outline: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ actionMenu }) =>
    actionMenu &&
    css`
      align-self: stretch;
      padding: 0 12px;
    `}

  &:focus-visible {
    outline: ${({ actionMenu }) => (actionMenu ? `2px solid ${colors.primary.blue}` : '0')};
    outline-offset: -2px;
  }
`;

export const ItemDeleteButtonWrapper = styled.div<{ actionMenu?: boolean }>`
  flex-shrink: 0;
  padding-right: ${spacing.xxsmall};
  ${({ actionMenu }) =>
    actionMenu &&
    css`
      padding-right: 12px;

      button > div {
        height: 24px;
        width: 24px;
      }
    `}
`;
